import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { Variants } from 'framer-motion';

export type SlideDirection = 1 | -1; // 1 = forward

type SlideTransitionProps = {
  slideKey: React.Key;
  direction: SlideDirection;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

const OFFSET = 48;

const slideVariants: Variants = {
  enter: (direction: SlideDirection) => ({ x: direction * OFFSET, opacity: 0 }),
  center: { x: 0, opacity: 1 },
  exit: (direction: SlideDirection) => ({ x: -direction * OFFSET, opacity: 0 }),
};

export function SlideTransition({
  slideKey,
  direction,
  disabled,
  className,
  children,
}: SlideTransitionProps) {
  const prefersReducedMotion = useReducedMotion();

  if (disabled || prefersReducedMotion)
    return <div className={className}>{children}</div>;

  return (
    <AnimatePresence initial={false} custom={direction} mode='popLayout'>
      <motion.div
        key={slideKey}
        custom={direction}
        variants={slideVariants}
        initial='enter'
        animate='center'
        exit='exit'
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className={className}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
